"use strict";
// @ts-ignore
try {
    self['workbox:broadcast-update:6.1.5'] && _();
}
catch (e) { }
